import wbabimg1 from '../images/project/wbab/1.webp'
import wbabimg2 from '../images/project/wbab/2.png'
import wbabimg3 from '../images/project/wbab/3.png'
import wbabimg4 from '../images/project/wbab/4.png'

import uselectimg1 from '../images/project/uselect/rainbird-logo.png'
import uselectimg2 from '../images/project/uselect/1.png'
import uselectimg3 from '../images/project/uselect/2.png'
import uselectimg4 from '../images/project/uselect/3.png'

import palomaimg1 from '../images/project/paloma/paloma-logo.jpg'
import palomaimg2 from '../images/project/paloma/1.png'
import palomaimg3 from '../images/project/paloma/2.png'
import palomaimg4 from '../images/project/paloma/3.png'

import oringimg1 from '../images/project/oring/oring-logo.png'
import oringimg2 from '../images/project/oring/1.png'
import oringimg3 from '../images/project/oring/2.png'
import oringimg4 from '../images/project/oring/3.png'

import limeliteimg1 from '../images/project/limelite/limelite-logo.webp'
import limeliteimg2 from '../images/project/limelite/1.png'
import limeliteimg3 from '../images/project/limelite/2.png'
import limeliteimg4 from '../images/project/limelite/3.png'

import jfimg1 from '../images/project/jf/jf-logo.png'
import jfimg2 from '../images/project/jf/1.png'
import jfimg3 from '../images/project/jf/2.png'
import jfimg4 from '../images/project/jf/3.png'

import goinimg1 from '../images/project/goin/goin-logo.png'
import goinimg2 from '../images/project/goin/1.png'
import goinimg3 from '../images/project/goin/2.png'
import goinimg4 from '../images/project/goin/3.png'

import ggimg1 from '../images/project/gg/gg-logo.png'
import ggimg2 from '../images/project/gg/1.png'
import ggimg3 from '../images/project/gg/2.png'
import ggimg4 from '../images/project/gg/3.png'

import fundifyimg1 from '../images/project/fundify/fundify-logo.jpg'
import fundifyimg2 from '../images/project/fundify/1.png'
import fundifyimg3 from '../images/project/fundify/2.png'
import fundifyimg4 from '../images/project/fundify/3.png'

const Projects = [
    {
        Id: '1',
        pImg: wbabimg1,
        ps1img: wbabimg2,
        psub1img1: wbabimg3,
        psub1img2: wbabimg4,
        title: 'WBAB Mobile app development',
        subTitle: 'React Native',
        description: `WBAB is a leading radio station offering a seamless listening experience for its users through its mobile application. The app provides live streaming, on-demand content, and personalized features to enhance user engagement. As a React Native Developer, I contributed to the development and enhancement of the WBAB mobile application, ensuring a smooth and consistent user experience across both iOS and Android platforms.`,
        client: 'WBAB',
        projectType: 'Mobile App Development',
        duration: '6 months',
        link: 'https://www.wbab.com/',
        strategy: `I implemented a dynamic theme parse/render engine to enable real-time customization of the app's UI/UX. Key strategies included:
        - Designed and implemented a dynamic theme parse/render engine.
        - Developed and maintained features using React Native.
        - Improved the app's user interface by implementing responsive designs and animations.`,
        testimonial: `"Amazing looking theme and instantly turns your application into a great looking one. Really shows that professionals built this theme up. Very happy with the way the theme looks." - Robert, WBAB`,
        approach: `I focused on ensuring a smooth and consistent user experience across both iOS and Android platforms. This involved close collaboration with the design and backend teams to integrate RESTful APIs for seamless data flow and functionality.`,
        goals: [
            'Implement a dynamic theme parse/render engine.',
            'Develop and maintain features using React Native.',
            'Improve the app\'s user interface with responsive designs and animations.',
            'Ensure a smooth and consistent user experience across both iOS and Android platforms.',
            'Collaborate with design and backend teams to integrate RESTful APIs.'
        ],
        result: [
            'Successfully implemented the dynamic theme engine, reducing the time required for UI updates by 40%.',
            'Contributed to a 20% increase in user engagement by enhancing the app\'s performance and user interface.',
            'Played a key role in ensuring the app\'s stability and scalability, supporting thousands of active users.'
        ]
    },
    {
        Id: '2',
        pImg: uselectimg1,
        ps1img: uselectimg2,
        psub1img1: uselectimg3,
        psub1img2: uselectimg4,
        title: 'UniformitySelect for Rainbird Sprinklers',
        subTitle: 'Full Stack Development',
        description: `UniformitySelect is a web-based tool designed to optimize sprinkler system selection, helping users calculate the ideal sprinkler setup based on their needs. I led the full-stack development of this project from scratch, transitioning the application from a legacy PHP codebase to a modern, scalable Node.js solution.`,
        client: 'Rainbird Sprinklers',
        projectType: 'Web Development',
        duration: '2 months',
        link: 'https://www.rainbird.com/',
        strategy: `I meticulously converted the original PHP-based sprinkler calculation logic to ensure the tool’s functionality and accuracy were maintained. Key strategies included:
        - Transitioned the application from a legacy PHP codebase to a modern, scalable Node.js solution.
        - Revamped the entire sprinkler search flow to enhance usability.
        - Built the front end using Next.js for optimal performance and SEO.`,
        testimonial: `"The result is a powerful, user-friendly platform that simplifies sprinkler system selection for Rainbird’s customers." - Stuart, Rainbird Sprinklers`,
        approach: `I focused on ensuring optimal performance, scalability, and a responsive user experience across devices by utilizing Next.js.`,
        goals: [
            'Transition the application from a legacy PHP codebase to a modern, scalable Node.js solution.',
            'Revamp the entire sprinkler search flow to enhance usability.',
            'Ensure optimal performance and SEO using Next.js.',
            'Maintain the tool’s functionality and accuracy.',
            'Provide a user-friendly platform for Rainbird’s customers.'
        ],
        result: [
            'Successfully transitioned the application to a modern, scalable Node.js solution.',
            'Enhanced usability with a revamped sprinkler search flow.',
            'Delivered a fast, responsive, and SEO-optimized user interface.',
            'Maintained the tool’s functionality and accuracy.',
            'Simplified sprinkler system selection for Rainbird’s customers.'
        ]
    },
    {
        Id: '3',
        pImg: oringimg1,
        ps1img: oringimg2,
        psub1img1: oringimg3,
        psub1img2: oringimg4,
        title: 'Ouraring Platform Development',
        subTitle: 'Full Stack Development',
        description: `As part of the team behind the Oura Ring website, I contributed to the design, development, and user experience of a modern, clean, and functional online presence. The website effectively communicates the ring's unique value proposition in sleep tracking, activity monitoring, and health insights while delivering a seamless user experience.`,
        client: 'Ouraring',
        projectType: 'Web and Mobile Development',
        duration: '6+ months',
        link: 'https://ouraring.com/',
        strategy: `I worked on creating an elegant yet approachable web experience. Key strategies included:
        - Collaborated with design team on layout, typography, and brand-aligned visuals
        - Built responsive pages using modern web technologies
        - Implemented user-friendly e-commerce functionality
        - Optimized site performance and loading times`,
        testimonial: `"The new website successfully combines elegant design with powerful functionality, effectively showcasing our product while driving conversions through an intuitive user experience." - Oura Ring Team`,
        approach: `I focused on creating a seamless user experience by leveraging HTML, CSS, JavaScript, and modern web technologies while ensuring optimal performance across all devices. Regular user testing and iteration helped refine the overall experience.`,
        goals: [
           'Create an elegant, brand-aligned website design',
           'Build responsive pages with smooth interactions',
           'Implement intuitive e-commerce functionality',
           'Optimize site performance and loading times',
           'Conduct user testing and iterate on feedback'
        ],
        result: [
           'Delivered a modern, clean website that effectively communicates product value',
           'Successfully integrated e-commerce functionality for direct sales',
           'Improved site performance and responsiveness across devices',
           'Created an effective educational hub and sales channel',
           'Enhanced overall user experience through iterative improvements'
        ]
    },
    {
        Id: '4',
        pImg: palomaimg1,
        ps1img: palomaimg2,
        psub1img1: palomaimg3,
        psub1img2: palomaimg4,
        title: 'Paloma Model and Talent Submission & Management Web App',
        subTitle: 'Full Stack Development',
        description: `I developed the Paloma Model and Talent web app from scratch using Next.js. This platform serves as a submission and management tool for models and talent, allowing seamless interaction between clients and the agency.`,
        client: 'Paloma',
        projectType: 'Web Development',
        duration: '4 months',
        link: 'https://palomamodelandtalent.com/',
        strategy: `I ensured optimal performance, scalability, and a responsive user experience across devices by utilizing Next.js. Key strategies included:
        - Developed the platform from scratch using Next.js.
        - Handled talent submissions, profiles, and digital portfolios.
        - Offered robust management features for both talent agents and clients.`,
        testimonial: `"The app handles talent submissions, profiles, and digital portfolios, while also offering robust management features for both talent agents and clients." - Client, Paloma`,
        approach: `I focused on ensuring optimal performance, scalability, and a responsive user experience across devices by utilizing Next.js.`,
        goals: [
            'Develop the platform from scratch using Next.js.',
            'Handle talent submissions, profiles, and digital portfolios.',
            'Offer robust management features for both talent agents and clients.',
            'Ensure optimal performance and scalability.',
            'Provide a responsive user experience across devices.'
        ],
        result: [
            'Successfully developed the platform from scratch using Next.js.',
            'Handled talent submissions, profiles, and digital portfolios.',
            'Offered robust management features for both talent agents and clients.',
            'Ensured optimal performance and scalability.',
            'Provided a responsive user experience across devices.'
        ]
    },
    {
        Id: '5',
        pImg: limeliteimg1,
        ps1img: limeliteimg2,
        psub1img1: limeliteimg3,
        psub1img2: limeliteimg4,
        title: 'Limelite',
        subTitle: 'Full-stack Web and Mobile Application',
        description: `I played a key role in the development of Limelite, a comprehensive web and mobile platform built from scratch using React, React Native, Express, and MongoDB. My contributions spanned both front-end and back-end development, with a focus on user experience and system efficiency.`,
        client: 'Limelite',
        projectType: 'Web and Mobile Development',
        duration: '1+ year',
        link: 'https://www.limelite.com/',
        strategy: `I developed a robust file management system and implemented a feature that allows users to capture content, rate it, and provide feedback. Key strategies included:
        - Developed a robust file management system.
        - Implemented a capture, rating, and feedback system.
        - Ensured cross-platform support using React Native.`,
        testimonial: `"This project allowed me to leverage my full-stack development skills to build an integrated solution that addressed both functional and performance needs, providing users with a seamless and intuitive experience." - Client, Limelite`,
        approach: `I focused on ensuring a smooth experience across both mobile and web platforms by utilizing React Native.`,
        goals: [
            'Develop a robust file management system.',
            'Implement a capture, rating, and feedback system.',
            'Ensure cross-platform support using React Native.',
            'Provide a seamless and intuitive user experience.',
            'Address both functional and performance needs.'
        ],
        result: [
            'Successfully developed a robust file management system.',
            'Implemented a capture, rating, and feedback system.',
            'Ensured cross-platform support using React Native.',
            'Provided a seamless and intuitive user experience.',
            'Addressed both functional and performance needs.'
        ]
    },
    {
        Id: '6',
        pImg: jfimg1,
        ps1img: jfimg2,
        psub1img1: jfimg3,
        psub1img2: jfimg4,
        title: 'Journeyfront',
        subTitle: 'Full Stack Development',
        description: `Journeyfront is a dynamic platform designed to enhance employee engagement and performance through data-driven insights and visualizations. As a full stack developer on this project, I contributed to both the backend and frontend development, ensuring a seamless and efficient user experience.`,
        client: 'Journeyfront',
        projectType: 'Web Development',
        duration: '2+ years',
        link: 'https://www.journeyfront.com/',
        strategy: `I built and maintained the backend using Django Rest Framework (DRF) and implemented the frontend using Vue.js. Key strategies included:
        - Built and maintained the backend using Django Rest Framework (DRF).
        - Implemented the frontend using Vue.js.
        - Developed data visualizations to present employee performance metrics.`,
        testimonial: `"This project allowed me to leverage my expertise in both backend and frontend technologies, delivering a high-quality platform that empowers organizations to make data-driven decisions about their workforce." - Client, Journeyfront`,
        approach: `I focused on ensuring a seamless and efficient user experience by integrating the frontend with the backend APIs.`,
        goals: [
            'Build and maintain the backend using Django Rest Framework (DRF).',
            'Implement the frontend using Vue.js.',
            'Develop data visualizations to present employee performance metrics.',
            'Ensure a seamless and efficient user experience.',
            'Empower organizations to make data-driven decisions about their workforce.'
        ],
        result: [
            'Successfully built and maintained the backend using Django Rest Framework (DRF).',
            'Implemented the frontend using Vue.js.',
            'Developed data visualizations to present employee performance metrics.',
            'Ensured a seamless and efficient user experience.',
            'Empowered organizations to make data-driven decisions about their workforce.'
        ]
    },
    {
        Id: '7',
        pImg: goinimg1,
        ps1img: goinimg2,
        psub1img1: goinimg3,
        psub1img2: goinimg4,
        title: 'Goin.org Platform Development',
        subTitle: 'Full Stack Development',
        description: `Goin.org is a comprehensive, Uber-like platform designed to provide seamless user experiences across web and mobile interfaces. The project involved building a robust, scalable system using modern technologies and best practices.`,
        client: 'Goin.org',
        projectType: 'Web and Mobile Development',
        duration: '1+ year',
        link: 'https://www.goin.org/',
        strategy: `I designed and implemented a microservices-based architecture using TypeScript. Key strategies included:
        - Designed and implemented a microservices-based architecture.
        - Developed the web application using React.
        - Built cross-platform mobile applications using React Native.`,
        testimonial: `"The platform not only meets but exceeds user expectations, providing a reliable and efficient service akin to industry leaders like Uber." - Client, Goin.org`,
        approach: `I focused on ensuring high performance, scalability, and maintainability by designing and implementing a microservices-based architecture using TypeScript.`,
        goals: [
            'Design and implement a microservices-based architecture.',
            'Develop a responsive and intuitive user interface.',
            'Build cross-platform mobile applications.',
            'Ensure real-time functionalities such as ride tracking, notifications, and dynamic pricing.',
            'Create a powerful admin dashboard for business owners and administrators.'
        ],
        result: [
            'Successfully delivered a comprehensive, Uber-like platform.',
            'Ensured high performance, scalability, and maintainability.',
            'Provided a consistent and native-like experience on both iOS and Android devices.',
            'Enhanced user experience with real-time functionalities.',
            'Empowered business owners with a powerful admin dashboard.'
        ]
    },
    {
        Id: '8',
        pImg: ggimg1,
        ps1img: ggimg2,
        psub1img1: ggimg3,
        psub1img2: ggimg4,
        title: 'Galaxy Creations Website Builder',
        subTitle: 'Full Stack Development',
        description: `At Galaxy Creations, I spearheaded the development of a dynamic website building and rendering system from the ground up. This innovative platform was designed to empower users to create and manage personalized, interactive websites with ease.`,
        client: 'Galaxy Creations',
        projectType: 'Web Development',
        duration: '2+ years',
        link: 'https://www.galaxycreations.com/',
        strategy: `I conceptualized and implemented a robust architecture that seamlessly integrated client-side and server-side scripting. Key strategies included:
        - Conceptualized and implemented a robust architecture.
        - Developed a scalable database schema.
        - Crafted an intuitive, user-friendly interface.`,
        testimonial: `"The successful deployment of this system significantly enhanced Galaxy Creations' service offerings, providing clients with a powerful tool to establish a dynamic online presence." - Client, Galaxy Creations`,
        approach: `I focused on creating a scalable, user-centric web application by integrating client-side and server-side scripting and developing a scalable database schema.`,
        goals: [
            'Conceptualize and implement a robust architecture.',
            'Develop a scalable database schema.',
            'Craft an intuitive, user-friendly interface.',
            'Ensure real-time content updates and an engaging user experience.',
            'Optimize server responses for swift page loads.'
        ],
        result: [
            'Successfully enhanced Galaxy Creations\' service offerings.',
            'Provided clients with a powerful tool to establish a dynamic online presence.',
            'Accommodated a diverse range of user requirements.',
            'Contributed to increased client satisfaction and engagement.',
            'Honed skills in full-stack web development.'
        ]
    },
    {
        Id: '9',
        pImg: fundifyimg1,
        ps1img: fundifyimg2,
        psub1img1: fundifyimg3,
        psub1img2: fundifyimg4,
        title: 'Fundify Investment Platform',
        subTitle: 'Full Stack Development',
        description: `Fundify is an innovative investment platform that democratizes access to startup investing. Fundify enables individuals to invest in early-stage companies with no minimum investment requirements, making startup investments accessible to a broader audience.`,
        client: 'Fundify',
        projectType: 'Web Development',
        duration: '3 months',
        link: 'https://www.fundify.com/',
        strategy: `I implemented responsive design principles and developed server-side logic. Key strategies included:
        - Implemented responsive design principles.
        - Developed and maintained server-side logic.
        - Integrated ProAdvisor features.`,
        testimonial: `"The successful implementation of these features contributed to Fundify's mission of simplifying startup investing, providing users with a platform that is both intuitive and powerful." - Client, Fundify`,
        approach: `I focused on ensuring a seamless and user-friendly experience for Fundify's investors by implementing responsive design principles and developing server-side logic.`,
        goals: [
            'Implement responsive design principles.',
            'Develop and maintain server-side logic.',
            'Integrate ProAdvisor features.',
            'Ensure efficient data processing and secure transactions.',
            'Enhance the user experience across various devices.'
        ],
        result: [
            'Successfully contributed to Fundify\'s mission of simplifying startup investing.',
            'Provided users with a platform that is both intuitive and powerful.',
            'Implemented robust security protocols to protect user data.',
            'Ensured compliance with financial regulations.',
            'Delivered comprehensive full-stack solutions in the fintech space.'
        ]
    }
]

export default Projects